var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-drive"},[_c('img',{attrs:{"src":require("@/assets/img/no-drive.svg")}}),_c('span',[_vm._v("禁止酒駕 飲酒過量 有害健康")])])}]

export { render, staticRenderFns }